







import {Component, Vue} from 'vue-property-decorator';
import GlobalHeader from "@/components/GlobalHeader.vue";
import PreparationBody from "@/components/preparation/PreparationBody.vue";
@Component({
  components: {GlobalHeader, PreparationBody}
})
export default class Preparation extends Vue {}
